






























































import { Component, Prop, Vue } from 'vue-property-decorator';
import BirthdayField from '@/components/form/BirthdayField.vue';
import CheckboxField from '@/components/form/CheckboxField.vue';
import TextField from '@/components/form/TextField.vue';
import SelectField from '@/components/form/SelectField.vue';
import { ValidationError } from 'class-validator';
import SelectOption from '@/types/form/SelectOption';
import User from '@/types/auth/User';
import i18next from 'i18next';

@Component({
  components: {
    BirthdayField,
    CheckboxField,
    TextField,
    SelectField,
  },
})
export default class RegisterStepOne extends Vue {
  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @Prop(Object)
  private user!: User;

  private isLoading: Boolean = true;

  public getFieldError(fieldName: string): ValidationError | null {
    const error = this.user.errors.find(e => e.property === fieldName);
    return error || null;
  }

  public removeFieldError(fieldName: string): void {
    let index = 0;
    this.user.errors.forEach((err, i) => {
      if (err.property === fieldName) {
        index = i;
      }
    });
    this.user.errors.splice(index, 1);
  }

  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 250);
  }

  public get salutationOptions(): Array<SelectOption> {
    return [
      { value: '', label: '' },
      { value: 'MR', label: i18next.t('salutation.MR') as string },
      { value: 'MRS', label: i18next.t('salutation.MRS') as string },
      { value: 'NONE', label: i18next.t('salutation.NONE') as string },
    ];
  }

  public get titleOptions(): Array<SelectOption> {
    return [
      { value: '', label: '' },
      {
        value: i18next.t('register.step.one.title.option.PHD') as string,
        label: i18next.t('register.step.one.title.option.PHD') as string,
      },
      {
        value: i18next.t('register.step.one.title.option.PROF') as string,
        label: i18next.t('register.step.one.title.option.PROF') as string,
      },
      {
        value: i18next.t('register.step.one.title.option.PHDPROF') as string,
        label: i18next.t('register.step.one.title.option.PHDPROF') as string,
      },
      {
        value: i18next.t('register.step.one.title.option.ENG') as string,
        label: i18next.t('register.step.one.title.option.ENG') as string,
      },
      {
        value: i18next.t('register.step.one.title.option.ENGMASTER') as string,
        label: i18next.t('register.step.one.title.option.ENGMASTER') as string,
      },
      {
        value: i18next.t('register.step.one.title.option.MAG') as string,
        label: i18next.t('register.step.one.title.option.MAG') as string,
      },
    ];
  }
}
